import { useAppStore } from "../stores/useAppStore";
import { AnimatePresence } from 'motion/react';
import AnalyticsWrapper from "./AnalyticsWrapper";
import AnimatedPath from "./AnimatedPath";
import useMenuNavigation from "../hooks/useMenuNavigation";

const Map = (props) => {
  const { content, mapOptions, setMapOptions } = useAppStore();
  const navigateTo = useMenuNavigation();
/*
  useEffect(() => {
    if (mapOptions.pillar) AnalyticsWrapper.trackPageView(`/demos/${mapOptions.pillar}`);
    else AnalyticsWrapper.trackPageView(`/demos`);

  }, [mapOptions.pillar]);
  */
  const handleClick = (id = null) => {    
    
    setMapOptions({ id });

    AnalyticsWrapper.trackEvent("map", "click_map_element", id);
  };

  const id = mapOptions.id;

  return (
    <div className={`relative ${props.className}`}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1560 1623"
    className="w-[97.5rem]"
  >
    <rect
      x={1}
      y={1}
      width={1558}
      height={1565}
      rx={69}
      fill="#0E2242"
      stroke="#E2E2E2"
      strokeWidth={2}
    />
    <rect
      x={83.6492}
      y={121.293}
      width={761.478}
      height={253.826}
      rx={10.8011}
      fill="#061933"
    />
    <rect
      x={532.975}
      y={1338.58}
      width={190.099}
      height={116.652}
      rx={10.8011}
      fill="#061933"
    />
    <rect
      x={135.494}
      y={1318.06}
      width={285.149}
      height={177.138}
      rx={9.72099}
      fill="#061933"
      stroke="#3070E7"
      strokeWidth={2.16022}
    />
    <rect
      x={1149.72}
      y={1139.84}
      width={254.906}
      height={145.815}
      rx={9.72099}
      fill="#061933"
      stroke="#3070E7"
      strokeWidth={2.16022}
    />
    <rect
      x={1149.72}
      y={424.804}
      width={254.906}
      height={145.815}
      rx={9.72099}
      fill="#061933"
      stroke="#3070E7"
      strokeWidth={2.16022}
    />
    <rect
      x={1149.72}
      y={974.58}
      width={254.906}
      height={146.895}
      rx={9.72099}
      fill="#061933"
      stroke="#3070E7"
      strokeWidth={2.16022}
    />
    <rect
      x={153.856}
      y={391.077}
      width={254.906}
      height={145.815}
      rx={9.72099}
      fill="#061933"
      stroke="#3070E7"
      strokeWidth={2.16022}
    />
    <rect
      x={524.334}
      y={391.077}
      width={254.906}
      height={145.815}
      rx={9.72099}
      fill="#061933"
      stroke="#3070E7"
      strokeWidth={2.16022}
    />
    <rect
      x={1149.72}
      y={259.547}
      width={254.906}
      height={146.895}
      rx={9.72099}
      fill="#061933"
      stroke="#3070E7"
      strokeWidth={2.16022}
    />

    {/* rectangle 1 */}
    {id === 1 && (
      <>
        <rect
          width={258}
          height={150}
          rx={10.8011}
          transform="matrix(1 0 0 -1 152.776 537.973)"
          fill="white"
        />
        <rect
          x={1.08011}
          y={-1.08011}
          width={241.84}
          height={135.84}
          rx={9.72099}
          transform="matrix(1 0 0 -1 159.776 529.812)"
          stroke="#03BCE9"
          strokeOpacity={0.34}
          strokeWidth={2.16022}
          fill="none"
        />
      </>
    )}

    {/* rectangle 2 */}
    {id === 2 && (
      <>
        <rect
          x={781.254}
          y={537.972}
          width={258}
          height={150}
          rx={10.8011}
          transform="rotate(180 781.254 537.972)"
          fill="white"
        />
        <rect
          x={773.174}
          y={530.892}
          width={241.84}
          height={135.84}
          rx={9.72099}
          transform="rotate(180 773.174 530.892)"
          stroke="#03BCE9"
          strokeOpacity={0.34}
          strokeWidth={2.16022}
          fill="none"
        />
      </>
    )}

    {/* rectangle 3 */}
    {id === 3 && (
      <>
        <rect x={1148} y={258} width={258} height={150} rx={10.8011} fill="white" />
        <rect
          x={1156.08}
          y={265.08}
          width={241.84}
          height={135.84}
          rx={9.72099}
          stroke="#03BCE9"
          strokeOpacity={0.34}
          strokeWidth={2.16022}
          fill="none"
        />
      </>
    )}

    {/* rectangle 4 */}
    {id === 4 && (
      <>
        <rect
          width={258}
          height={150}
          rx={10.8011}
          transform="matrix(1 0 0 -1 1149 573)"
          fill="white"
        />
        <rect
          x={1.08011}
          y={-1.08011}
          width={241.84}
          height={135.84}
          rx={9.72099}
          transform="matrix(1 0 0 -1 1156 564.84)"
          stroke="#03BCE9"
          strokeOpacity={0.34}
          strokeWidth={2.16022}
          fill="none"
        />
      </>
    )}

    {/* rectangle 5 */}
    {id === 5 && (
      <>
        <rect
          width={258}
          height={150}
          rx={10.8011}
          transform="matrix(1 0 0 -1 1149 1123)"
          fill="white"
        />
        <rect
          x={1.08011}
          y={-1.08011}
          width={241.84}
          height={135.84}
          rx={9.72099}
          transform="matrix(1 0 0 -1 1156 1114.84)"
          stroke="#03BCE9"
          strokeOpacity={0.34}
          strokeWidth={2.16022}
          fill="none"
        />
      </>
    )}

    {/* rectangle 6 */}
    {id === 6 && (
      <>
        <rect
          width={258}
          height={150}
          rx={10.8011}
          transform="matrix(1 0 0 -1 1149 1288)"
          fill="white"
        />
        <rect
          x={1.08011}
          y={-1.08011}
          width={241.84}
          height={135.84}
          rx={9.72099}
          transform="matrix(1 0 0 -1 1156 1279.84)"
          stroke="#03BCE9"
          strokeOpacity={0.34}
          strokeWidth={2.16022}
          fill="none"
        />
      </>
    )}

    <g filter="url(#filter0_f_162_2)">
      <rect
        x={135.495}
        y={1537.32}
        width={295.95}
        height={59.4061}
        rx={29.703}
        fill="url(#paint0_linear_162_2)"
      />
    </g>
    <rect
      x={136.575}
      y={1538.4}
      width={293.79}
      height={57.2459}
      rx={28.6229}
      fill="#061933"
      stroke="white"
      strokeWidth={2.16022}
    />
    <text
      x="283"
      y="1569"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="26"
      fill="white"
    >
      You are here
    </text>
    <ellipse cx={628.025} cy={1220.31} rx={77.768} ry={78.308} fill="#061933" />
    <text
      x="577"
      y="872"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="48"
      fill="#2F4574"
    >
      Tap on demo to explore
    </text>
    <AnimatePresence>
      {/* path 1 */}
      {id===1 && 
      <AnimatedPath
        key="path1"
        d="M431 1567H728.849C773.031 1567 808.849 1531.18 808.849 1487V819C808.849 774.817 773.031 739 728.849 739H334.407C302.651 739 276.907 713.256 276.907 681.5V681.5"
        stroke="url(#paint0_linear_179_24)"
        strokeWidth={5}
        fill="none"
      />}
      {/* path 2 */}
      {id===2 &&
      <AnimatedPath
        key="path2"
        d="M431 1567H728.849C773.031 1567 808.849 1531.18 808.849 1487V818.924C808.849 774.783 773.065 739 728.924 739H707C674.967 739 649 713.033 649 681V681"
        stroke="url(#paint0_linear_179_25)"
        strokeWidth={5}
        fill="none"
      />}
      {/* path 3 */}
      {id===3 &&
      <AnimatedPath
        key="path3"
        d="M431 1567H947.734C991.917 1567 1027.73 1531.18 1027.73 1487V274C1027.73 229.817 1063.55 194 1107.73 194H1188"
        stroke="url(#paint0_linear_179_21)"
        strokeWidth={5}
        fill="none"
      />}
      {/* path 4 */}
      {id===4 &&
      <AnimatedPath
        key="path4"
        d="M431 1567H947.734C991.917 1567 1027.73 1531.18 1027.73 1487V715C1027.73 670.817 1063.55 635 1107.73 635H1186"
        stroke="url(#paint0_linear_179_20)"
        strokeWidth={5}
        fill="none"
      />}
      {/* path 5 */}
      {id===5 &&
      <AnimatedPath
        key="path5"
        d="M431 1567H947.734C991.917 1567 1027.73 1531.18 1027.73 1487V996C1027.73 951.817 1063.55 916 1107.73 916H1186"
        stroke="url(#paint0_linear_177_19)"
        strokeWidth={5}
        fill="none"
      />}
      {/* path 6 */}
      {id===6 &&
      <AnimatedPath
        key="path6"
        d="M431 1567H1115.87H1198C1242.18 1567 1278 1531.18 1278 1487V1440"
        stroke="url(#paint0_linear_179_26)"
        strokeWidth={5}
        fill="none"
      />}
    </AnimatePresence>

    {/* circle1 */}
    <path
      opacity={0.5}
      d="M281.85 684.867C331.66 684.867 372.039 644.488 372.039 594.678C372.039 544.868 331.66 504.489 281.85 504.489C232.039 504.489 191.66 544.868 191.66 594.678C191.66 644.488 232.039 684.867 281.85 684.867Z"
      fill="#03BCE9"
    />
    <path
      d="M281.849 666.505C321.519 666.505 353.677 634.105 353.677 594.138C353.677 554.171 321.519 521.771 281.849 521.771C242.18 521.771 210.022 554.171 210.022 594.138C210.022 634.105 242.18 666.505 281.849 666.505Z"
      fill={ id === 1 ? "#03BCE9" :"white" }
      onClick={() => handleClick(1)}
    />
    <text
      x="282"
      y="596"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="78"
      pointerEvents="none"
      fill={ id === 1 ? "white" : "#03BCE9" }
    >
      1
    </text>

    {/* circle2 */}
    <path
      opacity={0.5}
      d="M651.247 684.867C701.057 684.867 741.436 644.488 741.436 594.678C741.436 544.868 701.057 504.489 651.247 504.489C601.437 504.489 561.058 544.868 561.058 594.678C561.058 644.488 601.437 684.867 651.247 684.867Z"
      fill="#03BCE9"
    />
    <path
      d="M651.247 666.505C690.916 666.505 723.075 634.105 723.075 594.138C723.075 554.171 690.916 521.771 651.247 521.771C611.578 521.771 579.42 554.171 579.42 594.138C579.42 634.105 611.578 666.505 651.247 666.505Z"
      fill={ id === 2 ? "#03BCE9" :"white" }
      onClick={() => handleClick(2)}
    />
    <text
      x="652"
      y="598"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="78"
      pointerEvents="none"
      fill={ id === 2 ? "white" : "#03BCE9" }
    >
      2
    </text>

    {/* circle3 */}
    <path
      opacity={0.5}
      d="M1276.09 290.87C1325.6 290.87 1365.74 250.491 1365.74 200.681C1365.74 150.871 1325.6 110.492 1276.09 110.492C1226.58 110.492 1186.44 150.871 1186.44 200.681C1186.44 250.491 1226.58 290.87 1276.09 290.87Z"
      fill="#03BCE9"
    />
    <path
      d="M1276.63 273.588C1316.3 273.588 1348.46 241.188 1348.46 201.221C1348.46 161.254 1316.3 128.854 1276.63 128.854C1236.96 128.854 1204.8 161.254 1204.8 201.221C1204.8 241.188 1236.96 273.588 1276.63 273.588Z"
      fill={ id === 3 ? "#03BCE9" :"white" }
      onClick={() => handleClick(3)}
    />
    <text
      x="1277"
      y="206"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="78"
      pointerEvents="none"
      fill={ id === 3 ? "white" : "#03BCE9" }
    >
      3
    </text>

    {/* circle4 */}
    <path
      opacity={0.5}
      d="M1276.09 727.235C1325.6 727.235 1365.74 686.856 1365.74 637.046C1365.74 587.235 1325.6 546.856 1276.09 546.856C1226.58 546.856 1186.44 587.235 1186.44 637.046C1186.44 686.856 1226.58 727.235 1276.09 727.235Z"
      fill="#03BCE9"
    />
    <path
      d="M1276.63 708.873C1316.3 708.873 1348.46 676.473 1348.46 636.506C1348.46 596.538 1316.3 564.138 1276.63 564.138C1236.96 564.138 1204.8 596.538 1204.8 636.506C1204.8 676.473 1236.96 708.873 1276.63 708.873Z"
      fill={ id === 4 ? "#03BCE9" : "white" }
      onClick={() => handleClick(4)}
    />
    <text
      x="1278"
      y="640"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="78"
      pointerEvents="none"
      fill={ id === 4 ? "white" : "#03BCE9" }
    >
      4
    </text>

    {/* circle5 */}
    <path
      opacity={0.5}
      d="M1276.09 1005.9C1325.6 1005.9 1365.74 965.282 1365.74 915.174C1365.74 865.066 1325.6 824.445 1276.09 824.445C1226.58 824.445 1186.44 865.066 1186.44 915.174C1186.44 965.282 1226.58 1005.9 1276.09 1005.9Z"
      fill="#03BCE9"
    />
    <path
      d="M1276.63 987.541C1316.3 987.541 1348.46 955.141 1348.46 915.174C1348.46 875.207 1316.3 842.807 1276.63 842.807C1236.96 842.807 1204.8 875.207 1204.8 915.174C1204.8 955.141 1236.96 987.541 1276.63 987.541Z"
      fill={ id === 5 ? "#03BCE9" :"white" }
      onClick={() => handleClick(5)}
    />

    <text
      x="1278"
      y="920"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="78"
      pointerEvents="none"
      fill={ id === 5 ? "white" : "#03BCE9" }
    >
      5
    </text>

    {/* circle6 */}
    <path
      opacity={0.5}
      d="M1276.09 1441.19C1325.6 1441.19 1365.74 1400.81 1365.74 1351C1365.74 1301.19 1325.6 1260.81 1276.09 1260.81C1226.58 1260.81 1186.44 1301.19 1186.44 1351C1186.44 1400.81 1226.58 1441.19 1276.09 1441.19Z"
      fill="#03BCE9"
    />
    <path
      d="M1276.63 1423.91C1316.3 1423.91 1348.46 1391.51 1348.46 1351.54C1348.46 1311.57 1316.3 1279.17 1276.63 1279.17C1236.96 1279.17 1204.8 1311.57 1204.8 1351.54C1204.8 1391.51 1236.96 1423.91 1276.63 1423.91Z"
      fill={ id === 6 ? "#03BCE9" : "white" }
      onClick={() => handleClick(6)}
    />
    <text
      x="1278"
      y="1356"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="78"
      pointerEvents="none"
      fill={ id === 6 ? "white" : "#03BCE9" }
    >
      6
    </text>
    
    <defs>
      <filter
        id="filter0_f_162_2"
        x={109.572}
        y={1511.39}
        width={347.796}
        height={111.251}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={12.9613}
          result="effect1_foregroundBlur_162_2"
        />
      </filter>
      <linearGradient
        id="paint0_linear_162_2"
        x1={135.495}
        y1={1549.28}
        x2={425.732}
        y2={1612.14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#02C8FF" />
        <stop offset={0.360577} stopColor="#0A60FF" />
        <stop offset={0.711693} stopColor="#FF007F" />
        <stop offset={1} stopColor="#FF9000" />
      </linearGradient>
      <linearGradient
        id="paint0_linear_179_25"
        x1={634.572}
        y1={1633.92}
        x2={357.952}
        y2={1134.38}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0A60FF" />
        <stop offset={0.293269} stopColor="#02C8FF" />
        <stop offset={0.711693} stopColor="#FF007F" />
        <stop offset={1} stopColor="#FF9000" />
      </linearGradient>
      <linearGradient
        id="paint0_linear_179_24"
        x1={634.572}
        y1={1633.92}
        x2={123.666}
        y2={1200.64}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0288462} stopColor="#0A60FF" />
        <stop offset={0.283654} stopColor="#02C8FF" />
        <stop offset={0.711693} stopColor="#FF007F" />
        <stop offset={1} stopColor="#FF9000" />
      </linearGradient>
      <linearGradient
        id="paint0_linear_177_19"
        x1={752.5}
        y1={1619.61}
        x2={621.018}
        y2={1142.67}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0A60FF" />
        <stop offset={0.326923} stopColor="#02C8FF" />
        <stop offset={0.711693} stopColor="#FF007F" />
        <stop offset={1} stopColor="#FF9000" />
      </linearGradient>
      <linearGradient
        id="paint0_linear_179_20"
        x1={752.5}
        y1={1642.32}
        x2={501.613}
        y2={1006.64}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.0528846} stopColor="#0A60FF" />
        <stop offset={0.375} stopColor="#02C8FF" />
        <stop offset={0.711693} stopColor="#FF007F" />
        <stop offset={1} stopColor="#FF9000" />
      </linearGradient>
      <linearGradient
        id="paint0_linear_179_21"
        x1={752.5}
        y1={1677.96}
        x2={282.19}
        y2={869.063}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0A60FF" />
        <stop offset={0.317308} stopColor="#02C8FF" />
        <stop offset={0.711693} stopColor="#FF007F" />
        <stop offset={1} stopColor="#FF9000" />
      </linearGradient>
      <linearGradient
        id="paint0_linear_179_26"
        x1={605.5}
        y1={1594}
        x2={646.865}
        y2={1371.83}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0A60FF" />
        <stop offset={0.346154} stopColor="#02C8FF" />
        <stop offset={0.711693} stopColor="#FF007F" />
        <stop offset={1} stopColor="#FF9000" />
      </linearGradient>
    </defs>
    
  </svg>
  </div>
);
};

export default Map;